var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIconPreseason(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 429,
    width: 21,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-18 -429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1123 4.375C14.767 3.27746 13.5973 2.66765 12.4997 3.01296 11.8505 3.21723 11.342 3.72577 11.1377 4.375L2.91667 4.375 2.91667 5.625 11.1377 5.625C11.483 6.72254 12.6527 7.33235 13.7502 6.98704 14.3995 6.78277 14.908 6.27423 15.1123 5.625L17.0833 5.625 17.0833 4.375ZM13.125 5.83333C12.6648 5.83333 12.2917 5.46023 12.2917 5 12.2917 4.53977 12.6648 4.16667 13.125 4.16667 13.5852 4.16667 13.9583 4.53977 13.9583 5 13.9583 5.46023 13.5852 5.83333 13.125 5.83333Z",
    fill: "#7030A0",
    transform: "matrix(1.05 0 0 1 18 429)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2917 12.9167C11.3822 12.9178 10.5783 13.5078 10.3044 14.375L2.91667 14.375 2.91667 15.625 10.3044 15.625C10.6497 16.7225 11.8194 17.3324 12.9169 16.987 13.5662 16.7828 14.0747 16.2742 14.279 15.625L17.0833 15.625 17.0833 14.375 14.279 14.375C14.005 13.5078 13.2011 12.9178 12.2917 12.9167ZM12.2917 15.8333C11.8314 15.8333 11.4583 15.4602 11.4583 15 11.4583 14.5398 11.8314 14.1667 12.2917 14.1667 12.7519 14.1667 13.125 14.5398 13.125 15 13.125 15.4602 12.7519 15.8333 12.2917 15.8333Z",
    fill: "#7030A0",
    transform: "matrix(1.05 0 0 1 18 429)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08333 7.91667C6.17392 7.91783 5.36996 8.50779 5.09604 9.375L2.91667 9.375 2.91667 10.625 5.09604 10.625C5.44135 11.7225 6.61104 12.3324 7.70858 11.987 8.35783 11.7828 8.86635 11.2742 9.07063 10.625L17.0833 10.625 17.0833 9.375 9.07063 9.375C8.79671 8.50779 7.99275 7.91783 7.08333 7.91667ZM7.08333 10.8333C6.6231 10.8333 6.25 10.4602 6.25 10 6.25 9.53977 6.6231 9.16667 7.08333 9.16667 7.54356 9.16667 7.91667 9.53977 7.91667 10 7.91667 10.4602 7.54356 10.8333 7.08333 10.8333Z",
    fill: "#7030A0",
    transform: "matrix(1.05 0 0 1 18 429)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconPreseason);
export default __webpack_public_path__ + "static/media/nav-icon-preseason.3d55a5144a6879febb2f00f4df234f0a.svg";
export { ForwardRef as ReactComponent };